import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import moment from 'moment';

import { checkDoubleBooking, zeroPad } from '../../../../../../../common/functions/utils';
import { checkReservationRequest } from '../../../../../../../general_redux/calendar/actions';
import { getNotificationList } from '../../../../../../../general_redux/notifications/actions';
import { loadGuests } from '../../../../../../../general_redux/guest/actions';
import styles from './ReservationRequestModal.module.css';


function ReservationRequestModal(props) {
  
  const {
    mode,
    show,
    onHide,
    handleDelete,
    values,
  } = props;

  const dispatch = useDispatch();

  const setting = useSelector(({ generalSetting }) => generalSetting && generalSetting.setting);
  const AllBookings = useSelector(({ calendar }) => calendar && calendar.allBooking);
  const rentals = useSelector(({ rentals }) => rentals && rentals.rentals);

  const [bookingRequestStatus, setBookingRequestStatus] = useState('Invalid');
  const [doubleBookingNumbers, setDoubleBookingNumbers] = useState('');

  const targetName = mode === 'notification' ? 'Notification' : 'Activity';
  const bookingData = (values?.bookingData && values.bookingData[0]);

  useEffect(() => {
    const now = new Date();
    const receivedAt = bookingData?.processedAt ? new Date(bookingData.processedAt) : null;
    const expired = receivedAt ? (now.getTime() - receivedAt.getTime()) >= 24 * 60 * 60 * 1000 : true;
  
    // TODO: fix bug related to timezone.
    const doubleBooking = checkDoubleBooking(
      bookingData?.arrive,
      bookingData?.depart,
      AllBookings,
      bookingData?.rentalId,
    );

    const bookingNumber = doubleBooking.map(item => `${new Date().getUTCFullYear()}${zeroPad(item.id, 4)}`);
    const result =
        bookingNumber.length <= 1
            ? bookingNumber[0] ?? ''
            : `${bookingNumber.slice(0, -1).join(', ')} and ${bookingNumber.at(-1)}`;
    setDoubleBookingNumbers(result);
  
    if (bookingData?.bookingStatus === 'Accepted') {
      setBookingRequestStatus('Accepted');
    } else if (bookingData?.bookingStatus === 'Rejected') {
      setBookingRequestStatus('Rejected');
    } else if (!expired && !doubleBooking.length) {
      setBookingRequestStatus('Valid');
    } else if (expired) {
      setBookingRequestStatus('Expired');
    } else {
      setBookingRequestStatus('Invalid');
    };
  }, [bookingData]);  

  const formatToFloat = (number) => {
    return number ? Number(number).toFixed(2) : '0.00';
  };

  const labelAndValueComponent = ({label, value, index}) => (
    <p key={index}>
      <span className={styles.firstColumn}>{label}</span>
      <span>{value}</span>
    </p>
  );

  const getGuestsNumber = (noOfGuests, noOfAdults, noOfChildren) => {
    if (noOfChildren) {
      return (
        <>
          <span>{noOfGuests}</span>
          <span className={styles.guestsNumber}>{`(${noOfAdults} adults, ${noOfChildren} child)`}</span>
        </>
      );
    };
    return (
      <>
        <span>{noOfGuests}</span>
        <span className={styles.guestsNumber}>{`(${noOfAdults} adults)`}</span>
      </>
    );
  };
  
  const getRentalNameById = (rentalId) => {
    return rentals.find(rental => rental.id === rentalId)?.name || 'N/A';
  };

  const getGuestNameByBookingTitle = (bookingName) => {
    return bookingName.split('|')[0].trim();
  };

  const labelAndValueList = [
    { label: 'Rental:',           value: bookingData?.rentalId       && getRentalNameById(bookingData.rentalId) },
    { label: 'Name:',             value: bookingData?.title          && getGuestNameByBookingTitle(bookingData.title) },
    { label: 'Arrival date:',     value: bookingData?.arrive         && moment(bookingData?.arrive).format('DD MMMM YYYY') },
    { label: 'Departure date:',   value: bookingData?.depart         && moment(bookingData?.depart).format('DD MMMM YYYY') },
    { label: 'Total nights:',     value: bookingData?.nights },
    { label: 'Guests:',           value: bookingData?.noOfGuests     && bookingData?.noOfAdults && getGuestsNumber(bookingData.noOfGuests, bookingData.noOfAdults, bookingData.noOfChildren) },
    { label: 'Adults:',           value: bookingData?.noOfAdults },
    { label: 'Total:',            value: bookingData?.price          && formatToFloat(bookingData.price) },
    { label: 'Received:',         value: bookingData?.createdAt      && moment(bookingData?.createdAt).format('DD MMM YYYY hh:mm a') },
  ];

  const handleAction = (action) => {
    if (['Accept', 'Reject'].includes(action) && bookingData) {
      const payload = {
        id: bookingData.id,
        confirmation: action === 'Accept' ? true : false,
      };
      dispatch(checkReservationRequest(payload)).then(() => {
        dispatch(getNotificationList());
        dispatch(loadGuests());
      });
      // console.log(payload);
    };
    if (action === 'Delete' && values) {
      const { id } = values;
      handleDelete(id);
    };
    onHide();
  };

  const handleClose = () => {
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size='md'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id='contained-modal-title-vcenter'
          className={styles.modalTitle}
          >
          {values?.message}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <p>Details of the request:</p>
        <div className={styles.contentContainer}>
          { labelAndValueList.map((item, index)=> labelAndValueComponent({
            index: index,
            label: item.label,
            value: item.value,
          }))}
          <p className='mt-3'>
            <span className={styles.firstColumn}>Status:</span>
            <span
              style={{
                color: ['Accepted', 'Valid'].includes(bookingRequestStatus) ? 'green' : 'red',
              }}
            >
              {bookingRequestStatus}
            </span>
          </p>
        </div>
        <br />
          { bookingRequestStatus === 'Valid' && mode !== 'activity' ? (
            <>
              <p>Would you like to accept this reservation request?</p>
              <div className={styles.modalButtonContainer}>
                <button
                  onClick={() => handleAction('Accept')}
                  className={styles.greenButton}
                >
                  Accept
                </button>
                <button
                  onClick={() => handleAction('Reject')}
                  className={styles.redButton}
                >
                  Reject
                </button>
              </div>
            </>
          ) : (
            <>
              { mode !== 'activity' &&
                <>
                  { bookingRequestStatus === 'Accepted' && <p>You have already accepted this request.</p> }
                  { bookingRequestStatus === 'Rejected' && <p>You have rejected this request.</p> }
                  { bookingRequestStatus === 'Expired' && <p>This request can no longer be accepted.</p> }
                  { bookingRequestStatus === 'Invalid' && doubleBookingNumbers ? (
                        <>
                            <p>This request cannot be accepted because a double booking has been detected.</p>
                            <p>Reservations affected:</p>
                            <p>Reservation numbers {doubleBookingNumbers}.</p>
                        </>
                    ) : <p>This request cannot be accepted.</p>
                  }
                </>
              }
              <div className={styles.modalButtonContainer}>
                <button
                  onClick={handleClose}
                  className={styles.grayButton}
                >
                  Close
                </button>
                { mode === 'notification' &&
                  <button
                    onClick={() => handleAction('Delete')}
                    className={styles.redButton}
                  >
                    Delete Notification
                  </button>
                }
              </div>
            </>
          )}
      </Modal.Body>
    </Modal>
  );
}

export default ReservationRequestModal;